import { requestApiClient } from "../functions";

export default {
    findAllForClient: async () => {
        const res = await requestApiClient('/clients/adresses/find-all-for-client', 'GET');
        return res;
    },

    create: async (data) => {
        const res = await requestApiClient('/clients/adresses', 'POST', data);
        return res;
    },
}